import { useEffect, useRef } from "react";
import PreviewHeader from "../header";
import OrderTotals from "../../new-order/save-preview-delete/order-totals";

const PdfOrderSummary = ({
  pageSize,
  order,
  rebars,
  nets,
  piles,
  handleRefs,
  totalPages,
  rightToLeft,
}: any) => {
  const pageRef: any = useRef([]);

  useEffect(() => {
    handleRefs(pageRef);
  });

  const currentPage = Object.values(totalPages || {}).reduce(
    (total: number, value: any) =>
      total + Number(value || 0),
    0
  );

  return (
    <div
      className="pdf-document-page pdf-order-summary-page"
      style={{ height: `${pageSize}px` }}
      ref={(element) => {
        pageRef.current[0] = element;
      }}
    >
      <PreviewHeader
        order={order}
        showDetails={false}
        pageNo={currentPage || 1}
        totalPages={totalPages}
        rightToLeft={rightToLeft}
      />

      <div className="pdf-order-summary-page__content">
        <OrderTotals
          includeAsymmetricNets
          direction={rightToLeft ? "rtl" : "ltr"}
          rebars={rebars}
          nets={nets}
          piles={piles}
        />
      </div>
    </div>
  );
};

export default PdfOrderSummary;